import { Button, _decorator } from 'cc';
import ButtonEventEffect from './ButtonEventEffect';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ButtonSoundEffect')
@requireComponent(Button)
export default class ButtonSoundEffect extends ButtonEventEffect {
    @property({ formerlySerializedAs: 'audioClipKey' })
    private _audioClipKey = '';

    @property({ formerlySerializedAs: 'playOnTouchEnd' })
    private _playOnTouchEnd = true;

    @property({ formerlySerializedAs: 'playOnTouchStart' })
    private _playOnTouchStart = false;

    @property
    public get audioClipKey() {
        return this._audioClipKey;
    }
    public set audioClipKey(value) {
        if (value === this._audioClipKey) {
            return;
        }
        this._audioClipKey = value;
    }

    @property
    public get playOnTouchEnd() {
        return this._playOnTouchEnd;
    }
    public set playOnTouchEnd(value) {
        if (value === this._playOnTouchEnd) {
            return;
        }
        this._playOnTouchEnd = value;
    }

    @property
    public get playOnTouchStart() {
        return this._playOnTouchStart;
    }
    public set playOnTouchStart(value) {
        if (value === this._playOnTouchStart) {
            return;
        }
        this._playOnTouchStart = value;
    }

    protected onButtonTouchStart(): void {
        if (!this.playOnTouchStart) {
            return;
        }
        this.game.audio.playEffect(this.audioClipKey);
    }

    protected onButtonTouchEnd(): void {
        if (!this.playOnTouchEnd) {
            return;
        }
        this.game.audio.playEffect(this.audioClipKey);
    }
}
